import request from "@/utils/request";

// 查询友链列表
export function getFriendLinkList(params) {
  return request({
    url: "/admin/links",
    method: "get",
    params: params
  });
}

//新增友链
export function addFriendLink(data) {
  return request({
    url: "/admin/links",
    method: "post",
    data: data
  });
}

//修改友链
export function updateFriendLink(data) {
  return request({
    url: "/admin/links",
    method: "put",
    data: data
  });
}

//删除友链
export function removeFriendLink(data) {
  return request({
    url: "/admin/links",
    method: "delete",
    data: data
  });
}
